(function () {
  // Hero: pick a color to retint the hero and swap the photos.
  document.querySelectorAll('[data-c3-hero]').forEach(function (hero) {
    var swatches = hero.querySelectorAll('[data-c3-swatch]');
    swatches.forEach(function (btn) {
      // Start loading a color's photos as soon as someone points at or focuses its swatch.
      function warm() {
        var key = btn.getAttribute('data-c3-swatch');
        hero.querySelectorAll('[data-c3-main="' + key + '"], [data-c3-peek="' + key + '"]').forEach(function (img) {
          img.loading = 'eager';
        });
      }
      btn.addEventListener('pointerenter', warm);
      btn.addEventListener('focus', warm);
      btn.addEventListener('touchstart', warm, { passive: true });
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-c3-swatch');
        hero.setAttribute('data-c', key);
        swatches.forEach(function (s) { s.setAttribute('aria-pressed', s === btn ? 'true' : 'false'); });
        ['main', 'peek'].forEach(function (kind) {
          hero.querySelectorAll('[data-c3-' + kind + ']').forEach(function (img) {
            img.hidden = img.getAttribute('data-c3-' + kind) !== key;
          });
        });
      });
    });
  });

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Product photo rotators: fade through the photos on their own while on screen.
  // Hover, focus or a dot press holds it; reduced-motion visitors only get the dots.
  document.querySelectorAll('[data-c3-rotator]').forEach(function (box, n) {
    var slides = box.querySelectorAll('[data-c3-slide]');
    var dots = box.querySelectorAll('[data-c3-dot]');
    if (slides.length < 2) return;
    var index = 0, timer = null, held = false, visible = false;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) {
        s.classList.toggle('is-active', j === index);
        if (j === index) s.loading = 'eager';
      });
      dots.forEach(function (d, j) { d.setAttribute('aria-pressed', j === index ? 'true' : 'false'); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (reduceMotion || held || !visible || document.hidden) return;
      timer = setInterval(function () { show(index + 1); }, 3800 + n * 400);
    }

    dots.forEach(function (d, j) {
      d.addEventListener('click', function () { show(j); held = true; stop(); });
    });
    box.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { held = true; stop(); } });
    box.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { held = false; start(); } });
    box.addEventListener('focusin', function () { held = true; stop(); });
    box.addEventListener('focusout', function () { held = false; start(); });
    document.addEventListener('visibilitychange', start);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) {
          // Warm the other photos once the block is near the screen.
          slides.forEach(function (s) { s.loading = 'eager'; });
        }
        start();
      }, { threshold: 0.3 }).observe(box);
    } else {
      visible = true;
      start();
    }
  });

  // Colors section: point at (or tap) a color to see that color up close.
  document.querySelectorAll('.c3-mosaic').forEach(function (box) {
    var chips = box.querySelectorAll('[data-c3-mixchip]');
    var imgs = box.querySelectorAll('[data-c3-mix]');
    if (!chips.length) return;
    var pinned = null;

    var section = box.closest('[data-c3-colors]');
    function show(key) {
      imgs.forEach(function (img) { img.classList.toggle('is-on', img.getAttribute('data-c3-mix') === key); });
      // Tint the whole section to match, like the hero swatches do.
      if (section) {
        if (key === 'all') section.removeAttribute('data-c');
        else section.setAttribute('data-c', key);
      }
    }
    function rest() { show(pinned || 'all'); }

    show('all');
    chips.forEach(function (chip) {
      var key = chip.getAttribute('data-c3-mixchip');
      function warm() {
        box.querySelectorAll('[data-c3-mix="' + key + '"]').forEach(function (img) { img.loading = 'eager'; });
      }
      chip.addEventListener('pointerenter', function (e) { warm(); if (e.pointerType === 'mouse') show(key); });
      chip.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') rest(); });
      chip.addEventListener('focus', function () { warm(); show(key); });
      chip.addEventListener('blur', rest);
      chip.addEventListener('click', function () {
        pinned = pinned === key ? null : key;
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip && pinned ? 'true' : 'false'); });
        show(pinned || 'all');
      });
    });
    // Load every color's photo when the section nears the screen so the swap is instant.
    if ('IntersectionObserver' in window) {
      var io0 = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { imgs.forEach(function (img) { img.loading = 'eager'; }); io0.disconnect(); }
      }, { rootMargin: '400px' });
      io0.observe(box);
    }
  });

  // Clips play only while on screen, and never for people who prefer reduced motion.
  var videos = document.querySelectorAll('[data-c3-video]');
  if (!videos.length || !('IntersectionObserver' in window)) return;
  if (reduceMotion) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        var p = e.target.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        e.target.pause();
      }
    });
  }, { threshold: 0.4 });
  videos.forEach(function (v) { io.observe(v); });
})();
